import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "../initialState";
import api from "../../api";

export const GetSurveyUserReport = createAsyncThunk(
  "surveyUser/GetSurveyUserReport",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}survey/report/barchart/${data.id}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllSurveyUser = createAsyncThunk(
  "surveyUser/GetAllSurveyUser",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(`${api}survey/all${data.query}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleSurveyUser = createAsyncThunk(
  "surveyUser/GetSingleSurveyUser",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}survey/get_by_id/${data.id}/${data.idUser}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const surveyUserSlice = createSlice({
  name: "surveyUser",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get survey data to create a bar chart report
    builder.addCase(GetSurveyUserReport.pending, loadingHandler);
    builder.addCase(GetSurveyUserReport.fulfilled, fulfilledHandler);
    builder.addCase(GetSurveyUserReport.rejected, rejectedHandler);
    // get all survey
    builder.addCase(GetAllSurveyUser.pending, loadingHandler);
    builder.addCase(GetAllSurveyUser.fulfilled, fulfilledHandler);
    builder.addCase(GetAllSurveyUser.rejected, rejectedHandler);
    // get Single survey
    builder.addCase(GetSingleSurveyUser.pending, loadingHandler);
    builder.addCase(GetSingleSurveyUser.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleSurveyUser.rejected, rejectedHandler);
  },
});

export const { reset } = surveyUserSlice.actions;
export default surveyUserSlice.reducer;
